import {MainStates} from 'client/types';

export const selectNotifications = (state: MainStates) => {
  return state.toastNotifications.toastNotifications;
};
